import { render } from "./ShipmentsCheckoutGrid.vue?vue&type=template&id=38a83f3c"
import script from "./ShipmentsCheckoutGrid.vue?vue&type=script&lang=js"
export * from "./ShipmentsCheckoutGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__